import React from 'react'

interface NetdataLogoProps {
    className?: string
}

export default function NetdataLogo({ className = '' }: NetdataLogoProps) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 878.83 151.31">
            <path
                d="M842.52,27.33h-12.46l-30.62,84.13h11.29l8.8-25.2h32.17l8.25,25.2h12.07l-29.51-84.13Zm-6.7,12.49l12.35,37.17h-25.47l13.12-37.17Zm-53.79-12.49v10.02h-27.4V111.46h-11.18V37.35h-27.4v-10.02h65.99Zm-113.03,0h-12.46l-30.62,84.13h11.29l8.8-25.2h32.17l8.25,25.2h12.07l-29.51-84.13Zm-6.7,12.49l12.35,37.17h-25.47l13.12-37.17Zm-133.46-12.49h32.94c11.18,0,19.86,4.1,26.02,12.31,5.5,7.41,8.25,16.89,8.25,28.46,0,8.93-1.62,17.01-4.87,24.22-5.72,12.75-15.56,19.13-29.51,19.13h-32.83V27.33Zm30.73,74.39c3.73,0,6.79-.4,9.19-1.2,4.28-1.49,7.79-4.35,10.52-8.59,2.18-3.4,3.75-7.75,4.71-13.06,.55-3.17,.83-6.11,.83-8.82,0-10.42-2-18.52-6.01-24.28-4-5.77-10.45-8.65-19.35-8.65h-19.54V101.72h19.65Zm-63.98-64.37v-10.02h-65.99v10.02h27.4V111.46h11.18V37.35h27.4Zm-156.43-10.02h59.29v10.31h-48.55v25.54h44.9v9.74h-44.9v28.52h49.38v10.02h-60.12V27.33Zm-105.61,0h13.01l41.08,68.15V27.33h10.46V111.46h-12.35l-41.69-68.09V111.46h-10.52V27.33Z"
                fillRule="evenodd"
            />
            <path
                d="M111.4,144.62h-34.31L6.78,5.34H106.58c38.81,.07,70.25,32.35,70.27,72.16-.06,37.1-29.34,67.11-65.46,67.11Z"
                fill="#00ab44"
                fillRule="evenodd"
            />
        </svg>
    )
}
